import { BooleanValueProperty } from './properties/boolean-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbRicheditWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Formatted Text';
    this.name = 'fb-richedit';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({
        value: props.text ? (props.text.value === 'Label' ? '' : props.text.value) : '',
      }),
      content: new TextProperty(props.content || { title: 'Description' }),
      value: new TextProperty(props.value || ''),
      hideLabel: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : false,
      }),
      printing: props['printing']
        ? props['printing']
        : {
            group: 'Data',
            type: 'checkbox',
            title: 'Printing',
            value: 1,
            prefix: 'Disabled on Print',
            mapping: '',
          },
    };
    return properties;
  }
}
